import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWORK } from "../../../../common/constants/appRoad"
import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"

import { roadworksQueryKeys } from "./queryKeys"

export function useRoadworksStats(
    queryParameters,
    config = {},
) {

    const url = "roadworks/stats/"
    const parameters = useExtendWithSubnetworks(queryParameters, API_MODULE_ROADWORK)
    const queryKey = roadworksQueryKeys["stats"](parameters)

    return useRoadworksQuery(
        url,
        queryKey,
        parameters,
        { ...config },
    )
}